/**
 * Diseño Figma de la ficha (Luis, 29/09):
 * · Carruseles [data-la-carrusel]: bucle infinito, arrastrar con el ratón, flechas, "1/N"
 *   y cursor redondo con flecha que sigue al ratón (en móvil, deslizar con el dedo).
 * · Pasadores de pasos [data-la-pasos]: un paso visible, "‹ 1/4 ›".
 * · Sonido del vídeo [data-la-sonido] y "Agregar" de "Completa tu rutina" (abre el carrito).
 */
const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
const puntero = window.matchMedia('(hover: hover) and (pointer: fine)');

function carrusel(raiz) {
  const pista = raiz.querySelector('[data-la-pista]');
  const originales = $$('[data-la-item]', pista);
  const n = originales.length;
  if (!pista || n < 2) return;

  // Bucle: una copia delante y otra detrás; al salir de la tanda del medio se salta sin que se note.
  const clonar = (el) => {
    const c = el.cloneNode(true);
    c.setAttribute('aria-hidden', 'true');
    c.dataset.laClon = '';
    c.removeAttribute('data-shopify-editor-block');
    return c;
  };
  originales.forEach((el) => pista.append(clonar(el)));
  [...originales].reverse().forEach((el) => pista.prepend(clonar(el)));

  const ancho = () => originales[1].offsetLeft - originales[0].offsetLeft;
  const inicio = () => originales[0].offsetLeft - pista.offsetLeft;
  const tanda = () => ancho() * n;
  const colocar = () => { pista.scrollLeft = inicio(); };
  requestAnimationFrame(colocar);
  window.addEventListener('resize', colocar);

  const pos = raiz.querySelector('[data-la-pos]');
  let rafId = 0;
  pista.addEventListener('scroll', () => {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      const t = tanda();
      if (pista.scrollLeft < inicio() - t / 2) pista.scrollLeft += t;
      else if (pista.scrollLeft > inicio() + t / 2 + t - ancho()) pista.scrollLeft -= t;
      const i = Math.round((pista.scrollLeft - inicio()) / ancho());
      if (pos) pos.textContent = String((((i % n) + n) % n) + 1);
    });
  }, { passive: true });

  const mover = (dir) => pista.scrollBy({ left: dir * ancho(), behavior: 'smooth' });
  raiz.querySelector('[data-la-prev]')?.addEventListener('click', () => mover(-1));
  raiz.querySelector('[data-la-next]')?.addEventListener('click', () => mover(1));

  // "Ver indicaciones +": abre el texto de la tarjeta (también en las copias).
  pista.addEventListener('click', (e) => {
    const b = e.target.closest('[data-la-mas]');
    if (!b) return;
    e.stopPropagation();
    const abierta = b.closest('[data-la-item]').classList.toggle('is-abierta');
    b.setAttribute('aria-expanded', String(abierta));
  });

  if (!puntero.matches) return;

  // Arrastrar con el ratón
  let x0 = 0, s0 = 0, arrastrando = false, movido = false;
  pista.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse' || e.target.closest('button, a')) return;
    arrastrando = true; movido = false; x0 = e.clientX; s0 = pista.scrollLeft;
    pista.classList.add('is-arrastrando');
  });
  window.addEventListener('pointermove', (e) => {
    if (!arrastrando) return;
    const dx = e.clientX - x0;
    if (Math.abs(dx) > 4) movido = true;
    pista.scrollLeft = s0 - dx;
  });
  window.addEventListener('pointerup', () => {
    if (!arrastrando) return;
    arrastrando = false;
    pista.classList.remove('is-arrastrando');
    // Encaja en la tarjeta más cercana
    const i = Math.round((pista.scrollLeft - inicio()) / ancho());
    pista.scrollTo({ left: inicio() + i * ancho(), behavior: 'smooth' });
  });

  // Cursor redondo con flecha: a la derecha avanza, a la izquierda retrocede (clic).
  const cursor = raiz.querySelector('.la-d-cursor');
  if (!cursor) return;
  pista.addEventListener('pointermove', (e) => {
    const sobreBoton = e.target.closest('button, a');
    const r = raiz.getBoundingClientRect();
    const izquierda = e.clientX < r.left + r.width * 0.35;
    cursor.textContent = izquierda ? '←' : '→';
    cursor.style.transform = `translate(${e.clientX - r.left}px, ${e.clientY - r.top}px)`;
    cursor.classList.toggle('is-visible', !sobreBoton);
    pista.classList.toggle('sin-cursor', !sobreBoton);
  });
  pista.addEventListener('pointerleave', () => { cursor.classList.remove('is-visible'); pista.classList.remove('sin-cursor'); });
  pista.addEventListener('click', (e) => {
    if (movido || e.target.closest('button, a')) return;
    mover(cursor.textContent === '←' ? -1 : 1);
  });
}

function pasos(raiz) {
  const items = $$('[data-la-paso]', raiz);
  const pos = raiz.querySelector('[data-la-pos]');
  let i = 0;
  const ir = (j) => {
    i = (j + items.length) % items.length;
    items.forEach((el, k) => el.classList.toggle('is-activo', k === i));
    if (pos) pos.textContent = String(i + 1);
  };
  raiz.querySelector('[data-la-prev]')?.addEventListener('click', () => { ir(i - 1); reiniciar(); });
  raiz.querySelector('[data-la-next]')?.addEventListener('click', () => { ir(i + 1); reiniciar(); });
  // Pasa solo cada N segundos (Dani, 30/09); se para con el ratón encima y vuelve a contar tras un clic.
  const seg = Number(raiz.dataset.laAuto) || 0;
  let t = null;
  const reiniciar = () => { if (!seg) return; clearInterval(t); t = setInterval(() => { if (!raiz.matches(':hover')) ir(i + 1); }, seg * 1000); };
  reiniciar();
  // Deslizar con el dedo
  let x0 = null;
  raiz.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
  raiz.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 40) ir(i + (dx < 0 ? 1 : -1));
    x0 = null;
  });
}

function iniciar(root = document) {
  $$('[data-la-carrusel]', root).forEach((el) => { if (!el.dataset.laListo) { el.dataset.laListo = '1'; carrusel(el); } });
  $$('[data-la-pasos]', root).forEach((el) => { if (!el.dataset.laListo) { el.dataset.laListo = '1'; pasos(el); } });
}

document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-la-sonido]');
  if (!b) return;
  const v = b.parentElement.querySelector('video');
  if (!v) return;
  v.muted = !v.muted;
  if (!v.muted) v.play();
  b.classList.toggle('is-activo', !v.muted);
});

// "Agregar" de "Completa tu rutina" y "Añadir" de la caja del Ritual: lo añade assets/la-carrito.js; aquí se abre el carrito.
document.addEventListener('la:carrito-oferta', (e) => {
  if (!['complemento', 'ritual'].includes(e.detail?.regla)) return;
  setTimeout(() => document.querySelector('cart-drawer-component')?.open?.(), 400);
});

iniciar();

// Miniaturas encima de la foto (Tati, 29/09): 4 a la vista, la elegida más oscura y flechas
// redondas a los lados para pasar por todas. Sirve para la galería de Shopify y para la del
// Ritual dentro de la Crema/Bálsamo (assets/la-oferta.js la crea al marcar esa opción).
const FLECHA = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M15 6l-6 6 6 6"/></svg>';
function tira(raiz) {
  if (raiz.dataset.laTira) return;
  const esShopify = raiz.matches('slideshow-component');
  const caja = esShopify ? raiz.querySelector('slideshow-controls') : raiz.querySelector('.la-oferta-galeria__miniaturas');
  if (!caja) return;
  let ventana, fila;
  if (esShopify) {
    ventana = raiz.querySelector('.slideshow-controls__thumbnails-container');
    fila = raiz.querySelector('.slideshow-controls__thumbnails');
  } else {
    ventana = document.createElement('div');
    ventana.className = 'la-tira__ventana';
    fila = document.createElement('div');
    fila.className = 'la-tira__fila';
    [...caja.querySelectorAll('[data-la-src]')].forEach((x) => fila.append(x));
    ventana.append(fila);
    caja.append(ventana);
  }
  const botones = () => [...fila.querySelectorAll(esShopify ? '.slideshow-controls__thumbnail' : '[data-la-src]')];
  if (!ventana || !fila || botones().length < 2) return;
  raiz.dataset.laTira = '1';
  raiz.classList.add('la-tira-activa');
  const POR_PAGINA = 4;
  let pagina = 0;
  const paginas = () => Math.ceil(botones().length / POR_PAGINA);
  const elegido = () => Math.max(0, botones().findIndex((x) => x.getAttribute('aria-selected') === 'true'));
  if (!esShopify) botones().forEach((b, i) => b.setAttribute('aria-selected', String(i === 0)));

  const izq = document.createElement('button');
  const der = document.createElement('button');
  [[izq, 'izq', 'Miniaturas anteriores'], [der, 'der', 'Más miniaturas']].forEach(([f, lado, txt]) => {
    f.type = 'button';
    f.className = `la-tira__flecha la-tira__flecha--${lado}`;
    f.setAttribute('aria-label', txt);
    f.innerHTML = FLECHA;
  });
  caja.prepend(izq);
  caja.append(der);

  // Las flechas solo pasan de página (4 primeras ↔ las siguientes); no cambian la foto.
  const pintar = () => {
    const b = botones();
    const paso = b.length > 1 ? b[1].offsetLeft - b[0].offsetLeft : 0;
    ventana.scrollLeft = 0;
    fila.style.transform = `translateX(${-pagina * POR_PAGINA * paso}px)`;
    izq.classList.toggle('is-oculta', pagina === 0);
    der.classList.toggle('is-oculta', pagina >= paginas() - 1);
  };
  izq.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); pagina = Math.max(0, pagina - 1); pintar(); });
  der.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); pagina = Math.min(paginas() - 1, pagina + 1); pintar(); });

  // Pasar el ratón por una miniatura cambia la foto (y se queda aunque se quite el ratón).
  const elegir = (b) => {
    if (!b || b.getAttribute('aria-selected') === 'true') return;
    b.click();
    if (!esShopify) botones().forEach((x) => x.setAttribute('aria-selected', String(x === b)));
  };
  fila.addEventListener('pointerover', (e) => {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    elegir(e.target.closest(esShopify ? '.slideshow-controls__thumbnail' : '[data-la-src]'));
  });
  fila.addEventListener('click', (e) => {
    const b = e.target.closest('[data-la-src]');
    if (b && !esShopify) botones().forEach((x) => x.setAttribute('aria-selected', String(x === b)));
  });
  // Si la foto cambia por otro motivo (deslizar en el móvil), la tira enseña la página de la elegida.
  let ultimo = elegido();
  new MutationObserver(() => {
    const i = elegido();
    if (i === ultimo) return; // solo cuando cambia de verdad la foto elegida
    ultimo = i;
    pagina = Math.floor(i / POR_PAGINA);
    pintar();
  }).observe(fila, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
  ventana.addEventListener('scroll', () => { if (ventana.scrollLeft) ventana.scrollLeft = 0; });
  requestAnimationFrame(pintar);
}
function tiras() {
  document.querySelectorAll('.product-information__media slideshow-component, .product-information__media .la-oferta-galeria').forEach(tira);
}
// Miniaturas como en el diseño de Tati (01/10): tira encima de la foto, abajo y centrada, 4 por página.
tiras();
const mediaFicha = document.querySelector('.product-information__media');
if (mediaFicha) new MutationObserver(tiras).observe(mediaFicha, { childList: true, subtree: true });

// Foto de la ficha: termina siempre 22 px por encima del borde inferior de la pantalla (cualquier pantalla).
function topeFoto() {
  const media = document.querySelector('.product-information__media');
  if (!media) return;
  const gal = [...media.querySelectorAll('.la-oferta-galeria, slideshow-component')].find((e) => e.offsetParent);
  if (!gal) return;
  media.style.removeProperty('--la-d-foto-max');
  media.style.removeProperty('--la-d-foto-alto');
  // 17 px entre el recuadro de la cabecera y la foto (se mide con la página arriba del todo).
  // Solo se puede medir con la página arriba del todo (la foto es sticky y la cabecera también):
  // se guarda por ancho de pantalla para cuando la página se abre ya bajada (Tati, 30/09).
  // Copia de trabajo (Tati, 01/10): en ordenador la foto va de la franja de 3 meses al borde de abajo
  // de la pantalla y pegada al borde izquierdo, sin huecos.
  const franja = window.innerWidth >= 750 ? document.querySelector('.la-franja') : null;
  const hueco_arriba = franja ? 0 : 17;
  const hueco_abajo = franja ? 0 : 22;
  if (franja) {
    // Con franja no se mide nada que dependa del scroll (la foto es sticky y medirla con la página
    // moviéndose dejaba todo descolocado hasta recargar, Tati 01/10): la franja no se mueve de su sitio
    // en la página, así que el alto sale de su posición fija.
    media.style.marginTop = '0px';
    const finFranja = franja.getBoundingClientRect().bottom + window.scrollY;
    const altoF = Math.ceil(window.innerHeight - finFranja);
    if (altoF < 200) return;
    media.style.setProperty('--la-d-foto-alto', `${altoF}px`);
    const infoF = document.querySelector('.product-information .product-details');
    if (infoF) { infoF.style.marginTop = '0px'; infoF.style.height = `${altoF}px`; }
    return;
  }
  const cab = franja || document.querySelector('.header__row--top');
  const clave = `la-subir-${window.innerWidth}`;
  if (cab && window.scrollY < 5) {
    media.style.marginTop = '0px';
    const hueco = gal.getBoundingClientRect().top - cab.getBoundingClientRect().bottom;
    media.dataset.laSubir = String(Math.round(hueco - hueco_arriba));
    try { sessionStorage.setItem(clave, media.dataset.laSubir); } catch {}
  } else if (!media.dataset.laSubir) {
    try { media.dataset.laSubir = sessionStorage.getItem(clave) || ''; } catch {}
  }
  media.style.marginTop = `${-Number(media.dataset.laSubir || 0)}px`;
  const r = gal.getBoundingClientRect();
  const extra = franja ? 0 : Math.max(0, r.height - r.width); // con franja: miniaturas encima de la foto // lo que haya bajo la foto (miniaturas encima o a la izquierda: nada)
  const alto = Math.ceil(window.innerHeight - hueco_abajo - (r.top + window.scrollY) - extra);
  if (alto < 200) return;
  // Móvil: foto cuadrada a lo ancho, sin estirarla al alto de la pantalla.
  if (window.innerWidth < 750) { media.style.removeProperty('--la-d-foto-alto'); media.style.marginTop = ''; return; }
  // La foto ocupa todo el ancho de su columna y llega hasta 22 px del borde inferior (recorta lo que sobre).
  media.style.setProperty('--la-d-foto-alto', `${alto}px`);
  // El recuadro del texto: misma altura y misma línea de arriba que la foto (en ordenador y tablet).
  const info = document.querySelector('.product-information .product-details');
  if (info) {
    if (window.innerWidth >= 750) {
      // La foto es sticky: con la página bajada su posición en pantalla no es la real. Por eso no se
      // compara con el recuadro, sino que se le da el mismo margen que a la foto (misma fila del grid).
      const dentro = gal.getBoundingClientRect().top - media.getBoundingClientRect().top;
      info.style.marginTop = `${Math.round(-Number(media.dataset.laSubir || 0) + dentro)}px`;
      info.style.height = `${Math.round(gal.getBoundingClientRect().height)}px`;
    } else {
      info.style.marginTop = '';
      info.style.height = '';
    }
  }
  // Recuadro de apartados (sections/la-secciones-ficha): mismo hueco arriba que abajo
  // por debajo del final de la foto y el texto. Se mide con el recuadro del texto, que no es sticky.
  const sf = document.querySelector('[data-la-secciones-ficha]');
  if (sf && info && window.innerWidth >= 750) {
    sf.style.setProperty('--la-sf-arriba', '0px');
    const fin = info.getBoundingClientRect().bottom;
    // Mismo aire arriba que el que queda entre el recuadro y la sección siguiente (Tati, 30/09).
    // Si debajo va "Cómo se usa" (sections/la-como-usar), los tres huecos son iguales: foto → apartados,
    // apartados → cómo se usa, y cómo se usa → la sección siguiente.
    const cu = document.querySelector('[data-la-como-usar]');
    const ultimo = cu ? cu.querySelector('.la-cu__caja') : (sf.querySelector('.la-sf__caja') || sf);
    const sig = (cu || sf).closest('.shopify-section')?.nextElementSibling;
    const abajo = sig ? Math.max(0, sig.getBoundingClientRect().top - ultimo.getBoundingClientRect().bottom) : 72;
    if (cu) cu.style.setProperty('--la-cu-arriba', '36px'); // 36 px entre apartados y cómo se usa (Tati, 30/09)
    const hueco = Math.round(fin + abajo - 3 - sf.getBoundingClientRect().top); // 3 px más arriba (Tati, 30/09)
    sf.style.setProperty('--la-sf-arriba', `${hueco}px`);
  } else if (sf) {
    sf.style.removeProperty('--la-sf-arriba');
  }
}
// Barra fija de compra con el texto en un recuadro con scroll propio (solo ordenador/tablet):
// sale al pasar el botón (bajando la página o dentro del recuadro) y se esconde en el pie.
function barraFija() {
  if (window.innerWidth < 750) return;
  const barra = document.querySelector('sticky-add-to-cart [data-stuck]');
  const caja = document.querySelector('.product-information .product-details');
  const boton = caja?.querySelector('.buy-buttons-block');
  if (!barra || !caja || !boton) return;
  const c = caja.getBoundingClientRect();
  const b = boton.getBoundingClientRect();
  const pie = document.querySelector('footer, [class*="footer-group"]')?.getBoundingClientRect();
  const botonVisible = b.bottom > Math.max(c.top, 0) && b.top < Math.min(c.bottom, window.innerHeight);
  const pasado = c.bottom < 0 || b.bottom <= c.top;
  const enPie = pie && pie.top < window.innerHeight;
  const debe = String(pasado && !botonVisible && !enPie);
  if (barra.dataset.stuck !== debe) barra.dataset.stuck = debe;
  if (!barra.dataset.laVigilada) {
    // Shopify también la enciende/apaga por su cuenta: aquí manda esta regla.
    barra.dataset.laVigilada = '1';
    new MutationObserver(() => requestAnimationFrame(barraFija)).observe(barra, { attributes: true, attributeFilter: ['data-stuck'] });
  }
}
window.addEventListener('scroll', barraFija, { passive: true });
document.querySelector('.product-information .product-details')?.addEventListener('scroll', barraFija, { passive: true });
window.addEventListener('load', topeFoto);
document.fonts?.ready.then(() => topeFoto());
// Si se abrió con la página bajada, se vuelve a medir la primera vez que llega arriba.
window.addEventListener('scroll', () => { if (window.scrollY < 5) requestAnimationFrame(topeFoto); }, { passive: true });
window.addEventListener('resize', () => requestAnimationFrame(topeFoto));
document.addEventListener('change', (e) => { if (e.target.closest('la-oferta')) setTimeout(topeFoto, 50); });
topeFoto();
document.addEventListener('shopify:section:load', (e) => iniciar(e.target));

// Foto principal propia del tema nuevo (custom.foto_principal, blocks/_product-media-gallery.liquid):
// sustituye la primera foto de la galería y su miniatura sin tocar las fotos del producto (Tati, 30/09).
function fotoPrincipal() {
  const tpl = document.querySelector('template[data-la-foto-principal]');
  if (!tpl) return;
  const nueva = tpl.content.querySelector('img');
  const mini = document.querySelector('template[data-la-foto-mini]')?.content.querySelector('img');
  const poner = (img, desde) => {
    if (!img || !desde || img.dataset.laFoto === desde.src) return;
    img.dataset.laFoto = desde.src;
    img.src = desde.src;
    if (desde.srcset) img.srcset = desde.srcset; else img.removeAttribute('srcset');
    img.alt = desde.alt || img.alt;
    if (desde.width) { img.width = desde.width; img.height = desde.height; }
  };
  for (const g of document.querySelectorAll('.product-information media-gallery')) {
    poner(g.querySelector('slideshow-slide img'), nueva);
    poner(g.querySelector('.slideshow-control img'), mini || nueva);
  }
  const zoom = document.querySelector('.dialog-zoomed-gallery img');
  poner(zoom, nueva);
}
fotoPrincipal();
new MutationObserver(fotoPrincipal).observe(document.body, { childList: true, subtree: true });

// Diseño Dani (30/09): una sola rueda. Mientras la foto y la info se ven enteras, la rueda (esté el ratón
// donde esté) baja primero la info hasta el final; después baja la página. Al subir, igual al revés.
(() => {
  const info = document.querySelector('.product-information .product-details');
  if (!info) return;
  window.addEventListener('wheel', (e) => {
    if (window.innerWidth < 750 || e.ctrlKey || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    const r = info.getBoundingClientRect();
    const entera = r.top >= -1 && r.bottom <= window.innerHeight + 1;
    if (!entera) return;
    const max = info.scrollHeight - info.clientHeight;
    if (max <= 0) return;
    const dy = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY;
    const puedeBajar = dy > 0 && info.scrollTop < max - 1;
    const puedeSubir = dy < 0 && info.scrollTop > 1;
    if (!puedeBajar && !puedeSubir) return;
    e.preventDefault();
    info.scrollTop = Math.max(0, Math.min(max, info.scrollTop + dy));
  }, { passive: false, capture: true });
})();

// Enlaces de la ficha a secciones que no están en esta página: se esconden en vez de no hacer nada.
document.querySelectorAll('.la-anclas a[href^="#"]').forEach((a) => {
  const id = a.getAttribute('href').slice(1);
  if (id && !document.getElementById(id)) a.hidden = true;
});

// Diseño Dani (Figma): la fila "ENVÍO" de los enlaces se despliega en el sitio con los 4 iconos de envío
// (Península, Punto de recogida, Europa, Tiendas físicas) en vez de bajar a otra sección.
(() => {
  const a = document.querySelector('.product-details .la-anclas a[href="#envio"]');
  const iconos = document.querySelector('.product-details .la-envio-iconos');
  if (!a || !iconos) return;
  const fila = document.createElement('div');
  fila.className = 'la-anclas__desplegable';
  const boton = document.createElement('button');
  boton.type = 'button';
  boton.className = 'la-anclas__boton';
  boton.textContent = a.textContent.trim();
  boton.setAttribute('aria-expanded', 'false');
  const cuerpo = document.createElement('div');
  cuerpo.className = 'la-anclas__cuerpo';
  const dentro = document.createElement('div');
  dentro.className = 'la-anclas__cuerpo-in';
  iconos.removeAttribute('id');
  dentro.append(iconos);
  cuerpo.append(dentro);
  fila.append(boton, cuerpo);
  a.replaceWith(fila);
  boton.addEventListener('click', () => {
    const abrir = boton.getAttribute('aria-expanded') !== 'true';
    boton.setAttribute('aria-expanded', String(abrir));
    fila.classList.toggle('is-abierta', abrir);
  });
})();

// Cinta de ingredientes (Tati, 30/09): avanza sola; se puede deslizar con el dedo o arrastrar con el ratón;
// con el ratón encima se para. En el iPhone la pausa por :hover se quedaba pegada: ahora siempre vuelve a andar.
document.querySelectorAll('.la-d-ing__ventana').forEach((ventana) => {
  const cinta = ventana.querySelector('.la-d-ing__cinta');
  if (!cinta || ventana.dataset.laCinta) return;
  ventana.dataset.laCinta = '1';
  ventana.classList.add('la-js');
  const seg = parseFloat(getComputedStyle(cinta).getPropertyValue('--la-vel')) || 40;
  let x = 0, ultimo = performance.now(), encima = false, arr = null, inercia = 0;
  const mitad = () => cinta.scrollWidth / 2;
  const ajustar = () => { const m = mitad(); if (m > 0) { while (x <= -m) x += m; while (x > 0) x -= m; } };
  const paso = (t) => {
    const dt = Math.min(64, t - ultimo); ultimo = t;
    if (!arr) {
      if (Math.abs(inercia) > 0.02) { x += inercia * dt; inercia *= 0.94; }
      else if (!encima) x -= (mitad() / (seg * 1000)) * dt;
    }
    ajustar();
    cinta.style.transform = `translate3d(${x}px,0,0)`;
    requestAnimationFrame(paso);
  };
  requestAnimationFrame(paso);
  ventana.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') encima = true; });
  ventana.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') encima = false; });
  ventana.addEventListener('pointerdown', (e) => {
    arr = { x0: e.clientX, y0: e.clientY, xi: x, lx: e.clientX, lt: performance.now(), v: 0, horizontal: null, id: e.pointerId };
    inercia = 0;
  });
  ventana.addEventListener('pointermove', (e) => {
    if (!arr) return;
    const dx = e.clientX - arr.x0, dy = e.clientY - arr.y0;
    if (arr.horizontal === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
      arr.horizontal = Math.abs(dx) > Math.abs(dy);
      if (arr.horizontal) { ventana.setPointerCapture(arr.id); ventana.classList.add('is-arrastrando'); }
    }
    if (!arr.horizontal) return;
    x = arr.xi + dx;
    const t = performance.now(); arr.v = (e.clientX - arr.lx) / Math.max(1, t - arr.lt); arr.lx = e.clientX; arr.lt = t;
  });
  const soltar = () => {
    if (!arr) return;
    if (arr.horizontal) inercia = Math.max(-3, Math.min(3, arr.v));
    arr = null; ventana.classList.remove('is-arrastrando');
  };
  ventana.addEventListener('pointerup', soltar);
  ventana.addEventListener('pointercancel', soltar);
});
